import { useQuery } from '@tanstack/react-query'
import { edgesApi } from '@/api/endpoints/edges'

export function useEdges() {
  return useQuery({
    queryKey: ['edges'],
    queryFn: () => edgesApi.list(),
    // Auto-refresh every 30 seconds to keep online status fresh
    refetchInterval: 30000,
  })
}
